<h2 class="section-title">
  {{ 'ADMIN.PROJECTS.PROJECTS' | translate }}
</h2>

<div class="actions">
  <mat-form-field color="accent" appearance="fill">
    <mat-label>{{ 'ADMIN.PROJECTS.PROJECT_SEARCH' | translate }}</mat-label>
    <input
      matInput
      type="text"
      (keyup.enter)="searchProject($event.target.value)"
      (blur)="searchProject($event.target.value)"
    />
  </mat-form-field>

  <div class="form-container" *appIfHasPermission="['viewAdmin.viewProjects.createProject']">
    <mat-form-field color="accent" appearance="fill">
      <mat-label> {{ 'ADMIN.PROJECTS.PROJECT_NAME' | translate }}</mat-label>
      <input matInput [(ngModel)]="newProjectName" (keyup.enter)="createNewProject()" />
    </mat-form-field>
    <button
      type="button"
      mat-raised-button
      class="add-button"
      color="primary"
      (click)="createNewProject()"
    >
      {{ 'ADMIN.PROJECTS.ADD' | translate }}
    </button>
  </div>
</div>

<div class="relative">
  @if (loading) {
    <div class="overlay">
      <mat-spinner class="spinner-reset" [diameter]="64"></mat-spinner>
    </div>
  }
  <table
    mat-table
    matSort
    [dataSource]="projects"
    (matSortChange)="
      applyFilter(
        $event.active && $event.direction && { field: $event.active, order: $event.direction }
      )
    "
  >
    <ng-container matColumnDef="oracleId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ID' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let project"
        [ngStyle]="isAdmin() && { width: '8rem', 'overflow-x': 'hidden' }"
      >
        {{ project.oracleId || '-' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_NAME' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let project"
        [ngStyle]="isAdmin() && { width: '16rem', 'overflow-x': 'hidden' }"
      >
        <a [routerLink]="['/dreamix/page/projects', project.id]" class="cell-link">
          {{ project.name }}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="manager">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ADMIN.PROJECTS.EDIT_PROJECT.PARTNERSHIP_MANAGER' | translate }}
      </th>
      <td mat-cell *matCellDef="let project">{{ project.manager || '-' }}</td>
    </ng-container>
    <ng-container matColumnDef="lead">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_LEAD' | translate }}
      </th>
      <td mat-cell *matCellDef="let project">{{ project.lead || '-' }}</td>
    </ng-container>
    <ng-container matColumnDef="engineeringManager">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_EM' | translate }}
      </th>
      <td mat-cell *matCellDef="let project">{{ project.engineeringManager || '-' }}</td>
    </ng-container>
    <ng-container matColumnDef="employeesCount">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ADMIN.PROJECTS.EDIT_PROJECT.TEAM_SIZE' | translate }}
      </th>
      <td mat-cell *matCellDef="let project">{{ project.employeesCount }}</td>
    </ng-container>
    <ng-container matColumnDef="billingType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'ADMIN.PROJECTS.STATUS' | translate }}
      </th>
      <td mat-cell *matCellDef="let project">
        {{ 'ADMIN.PROJECTS.BILLING_PROPERTIES.' + project.billingType | translate }}
      </td>
    </ng-container>
    @if (isAdmin()) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let project">
          <div class="action-buttons">
            <mat-icon
              matTooltip="{{ 'SHARED.EDIT' | translate }}"
              [routerLink]="['/admin/projects/update', project.id]"
              class="icon user-edit"
              *appIfHasPermission="['viewAdmin.viewProjects.editProject']"
              >edit</mat-icon
            >
            @if (!project.archived) {
              <mat-icon
                matTooltip="{{ 'SHARED.ARCHIVE' | translate }}"
                class="icon user-edit"
                (click)="archiveDialog(project)"
                *appIfHasPermission="['viewAdmin.viewProjects.archiveProject']"
                >archive</mat-icon
              >
            }
            @if (project.archived) {
              <mat-icon
                matTooltip="{{ 'SHARED.UNARCHIVE' | translate }}"
                class="icon user-edit"
                (click)="unArchiveDialog(project)"
                *appIfHasPermission="['viewAdmin.viewProjects.archiveProject']"
                >unarchive</mat-icon
              >
            }
            <mat-icon
              matTooltip="{{ 'SHARED.DELETE' | translate }}"
              class="icon delete"
              (click)="deleteDialog(project)"
              *appIfHasPermission="['viewAdmin.viewProjects.deleteProject']"
              >cancel</mat-icon
            >
          </div>
        </td>
      </ng-container>
    }

    @if (isLead()) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let project">
          <mat-icon
            matTooltip="{{ 'SHARED.EDIT' | translate }}"
            [routerLink]="['/lead/projects/update', project.id]"
            class="icon user-edit"
            >edit</mat-icon
          >
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let project; columns: displayedColumns"
      [ngClass]="{ archived: project.archived }"
    ></tr>
  </table>
</div>

@if (itemCount > 10) {
  <mat-paginator
    showFirstLastButtons
    [pageSizeOptions]="[route.snapshot.queryParams.size || 10]"
    [pageSize]="route.snapshot.queryParams.size || 10"
    [length]="itemCount"
    [pageIndex]="route.snapshot.queryParams.page - 1 || 0"
    (page)="applyFilter({ page: $event.pageIndex + 1 })"
  ></mat-paginator>
}
